// Presigned S3 links carry their credentials in the query string (X-Amz-Signature and the
// other X-Amz-* parameters). Sentry's fetch instrumentation copies the full URL into span
// attributes and breadcrumbs, so the signature reaches the logs even though our error
// messages leave it out on purpose (#1024). This strips the query string of any value that
// still carries a signature, keeping the path (bucket / key) for debugging.
const PRESIGNED_SIGNATURE_MARKER = 'X-Amz-Signature';
const REDACTED = '[Filtered]';

function redactPresignedUrl(value: string): string {
    if (!value.includes(PRESIGNED_SIGNATURE_MARKER)) {
        return value;
    }

    const queryStart = value.indexOf('?');
    if (queryStart === -1) {
        // A bare query string (e.g. the http.query span attribute), nothing to keep.
        return REDACTED;
    }

    return `${value.slice(0, queryStart)}?${REDACTED}`;
}

export { redactPresignedUrl };
